import { DEFAULT_VALUE, DEFAULT_VALUE_COUNTRY, EMPTY_LOCATION } from "../types/LoggingTypes";
export class GeoDimensions {
    constructor() {
        //infra
        this._geoUserCountry = DEFAULT_VALUE_COUNTRY;
        this._geoUserCity = DEFAULT_VALUE;
        //
        this._geoAppCountry = DEFAULT_VALUE_COUNTRY;
        this._geoPostCountry = DEFAULT_VALUE_COUNTRY;
        this._geoPostCity = DEFAULT_VALUE;
        this._geoUserLocation = EMPTY_LOCATION;
        this._geoPostLocation = EMPTY_LOCATION;
        this._geoPostNeighborhood = DEFAULT_VALUE;
        this.getGeoUserLocation();
    }
    static getInstance() {
        if (!GeoDimensions.instance) {
            GeoDimensions.instance = new GeoDimensions();
        }
        return GeoDimensions.instance;
    }
    reset() {
        this._geoPostCountry = DEFAULT_VALUE_COUNTRY;
        this._geoPostCity = DEFAULT_VALUE;
        this._geoPostLocation = EMPTY_LOCATION;
    }
    get geoUserCountry() {
        return this._geoUserCountry;
    }
    set geoUserCountry(_geoUserCountry) {
        this._geoUserCountry = _geoUserCountry;
    }
    get geoUserCity() {
        return this._geoUserCity;
    }
    set geoUserCity(_geoUserCity) {
        this._geoUserCity = _geoUserCity;
    }
    get geoAppCountry() {
        return this._geoAppCountry;
    }
    set geoAppCountry(_geoAppCountry) {
        this._geoAppCountry = _geoAppCountry;
    }
    get geoUserLocation() {
        return this._geoUserLocation;
    }
    get geoPostCountry() {
        return this._geoPostCountry;
    }
    set geoPostCountry(_geoPostCountry) {
        this._geoPostCountry = _geoPostCountry;
    }
    get geoPostCity() {
        return this._geoPostCity;
    }
    set geoPostCity(_geoPostCity) {
        this._geoPostCity = _geoPostCity;
    }
    get geoPostLocation() {
        return this._geoPostLocation;
    }
    set geoPostLocation(_geoPostLocation) {
        this._geoPostLocation = _geoPostLocation;
    }
    get geoPostNeighborhood() {
        return this._geoPostNeighborhood;
    }
    set geoPostNeighborhood(_geoPostNeighborhood) {
        this._geoPostNeighborhood = _geoPostNeighborhood;
    }
    getGeoUserLocation() {
        if (typeof navigator !== 'undefined' && navigator.geolocation) {
            if (typeof navigator.permissions !== 'undefined' && typeof navigator.permissions.query !== 'undefined') {
                navigator.permissions.query({ name: 'geolocation' }).then((state) => {
                    if (state.state === 'granted' || state.state === 'denied')
                        navigator.geolocation.getCurrentPosition(
                        //success
                        (positon) => {
                            const lat = positon.coords.latitude;
                            const long = positon.coords.longitude;
                            this._geoUserLocation = {
                                latitude: lat.toString(),
                                longitude: long.toString()
                            };
                        }, (error) => {
                        });
                });
            }
        }
    }
}
